import { Box, Button, Container, Typography, useTheme } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';

const Header = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const theme = useTheme();

    const navLinkStyle = {
        fontSize: { lg: '16px', sm: '14px' },
        cursor: 'pointer',
        fontWeight: 500,
        '&:hover': { color: theme.palette.primary.main }
    };

    return (
        <>
            <Box sx={{ backgroundColor: theme.palette.primary.main }}>
                <Container>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { lg: "24px", md: '24px', sm: '24px', xs: '12px' }, justifyContent: { lg: "space-between", md: "space-between", sm: "center", xs: "center" }, padding: '10px 0' }}>
                        <Typography sx={{ color: theme.palette.bgLightWhite?.main || '#fff', fontSize: '14px', lineHeight: '20px' }}>Patidar Parivar Suraksha Kavach</Typography>
                        <Box sx={{ display: 'flex', gap: { lg: "24px", md: '24px', sm: '20px', xs: '12px' }, flexWrap: 'wrap', justifyContent: { lg: "space-between", md: "space-between", sm: "center", xs: "center" } }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <img
                                    src="/images/call.svg"
                                    alt="phone"
                                    style={{ width: "20px", objectFit: "cover", filter: "invert(100%) sepia(100%) saturate(0%) hue-rotate(73deg) brightness(103%) contrast(103%)" }}
                                />
                                <Typography sx={{ color: theme.palette.bgLightWhite?.main || '#fff', fontSize: '14px', lineHeight: '20px', fontWeight: '400' }}> +91 98498 76476 | +91 99499 21021</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <img
                                    src="/images/sms-tracking.svg"
                                    alt="email"
                                    style={{ width: "20px", objectFit: "cover", filter: "invert(100%) sepia(100%) saturate(0%) hue-rotate(73deg) brightness(103%) contrast(103%)" }}
                                />
                                <Typography sx={{ color: theme.palette.bgLightWhite?.main || '#fff', fontSize: '14px', lineHeight: '20px' }}>info@ppsk.life</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
            <Box
                bgcolor="white"
                py={{ lg: '12px', md: "10px", sm: '8px', xs: '6px' }}
                sx={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}
            >
                <Container>
                    <Box
                        padding="3px"
                        top={0}
                        zIndex={100}
                        sx={{ display: 'flex', flexDirection: { lg: 'row', md: 'row', sm: 'row', xs: 'column' }, gap: { lg: '40px', md: '40px', sm: '20px', xs: '12px' }, justifyContent: { lg: 'space-between', md: 'space-between', sm: 'space-between', xs: 'center' }, alignItems: 'center' }}
                    >
                        <img src="/images/Frame-1000008385.png" alt="PPSK Logo" width="100%" height="auto" style={{ maxWidth: '284px', cursor: 'pointer' }} onClick={() => navigate("/")} />
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { lg: '20px', md: '16px', sm: '12px', xs: '10px' }, justifyContent: 'center', alignItems: 'center' }}>
                            <Typography sx={{ ...navLinkStyle, color: location?.pathname === "/" ? theme.palette.primary.main : 'inherit' }} onClick={() => navigate("/")}>Home</Typography>
                            <Typography sx={{ ...navLinkStyle, color: location?.pathname?.startsWith("/event") ? theme.palette.primary.main : 'inherit' }} onClick={() => navigate("/events")}>Events</Typography>
                            <Typography sx={{ ...navLinkStyle, color: location?.pathname === "/press-and-media" ? theme.palette.primary.main : 'inherit' }} onClick={() => navigate("/press-and-media")}>Press & Media</Typography>
                            <Typography sx={{ ...navLinkStyle, color: location?.pathname === "/about-us" ? theme.palette.primary.main : 'inherit' }} onClick={() => navigate("/about-us")}>About Us</Typography>
                            <Button
                                variant="outlined"
                                startIcon={<AdminPanelSettingsOutlinedIcon />}
                                sx={{
                                    padding: '6px 14px',
                                    borderRadius: '10px',
                                    borderColor: theme.palette.primary.main,
                                    color: theme.palette.primary.main,
                                    fontSize: { lg: '14px', md: '14px', sm: '13px', xs: '12px' },
                                    textTransform: 'none',
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.main,
                                        color: 'white',
                                    },
                                }}
                                onClick={() => navigate('/admin')}
                            >
                                Admin Panel
                            </Button>
                            <Button
                                sx={{
                                    padding: '6px 20px',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    borderRadius: '10px',
                                    backgroundColor: theme.palette.primary.main,
                                    color: 'white',
                                    fontSize: { lg: '14px', md: '14px', sm: '13px', xs: '12px' },
                                    fontFamily: 'Lato, sans-serif',
                                    textTransform: 'none',
                                    zIndex: 1,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.main,
                                    },
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        width: 0,
                                        height: 0,
                                        top: '50%',
                                        left: '50%',
                                        backgroundColor: '#9e110c',
                                        borderRadius: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: -1,
                                        transition: 'all 500ms ease-in-out',
                                    },
                                    '&:hover::before': {
                                        width: '300px',
                                        height: '300px',
                                    },
                                }}
                                onClick={() => navigate('/contact-us')}
                            >
                                Get in Touch
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </>
    )
}

export default Header